import functionDouble from 'function-double';
import { shallowTest } from './utils';
import { memoize } from './memoize';
export var isThisPure = function isThisPure(fnCall, message) {
  if (message === void 0) {
    message = 'isThisPure';
  }

  return shallowTest(fnCall(), fnCall(), false, message + ':result is not equal at [$KEYS$]');
};
export var shallBePure = function shallBePure(fnCall, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$message = _ref.message,
      message = _ref$message === void 0 ? 'shouldBePure' : _ref$message,
      _ref$checkAffectedKey = _ref.checkAffectedKeys,
      checkAffectedKeys = _ref$checkAffectedKey === void 0 ? true : _ref$checkAffectedKey,
      _ref$isolatedCheck = _ref.isolatedCheck,
      isolatedCheck = _ref$isolatedCheck === void 0 ? false : _ref$isolatedCheck,
      _ref$onTrigger = _ref.onTrigger,
      onTrigger = _ref$onTrigger === void 0 ? false : _ref$onTrigger;

  var memoized = checkAffectedKeys ? memoize(fnCall, {
    safe: true,
    isolatedCheck: isolatedCheck
  }) : memoize(fnCall);
  var lastResult = null;
  var lastMemoizedResult = null;

  function functor() {
    var mresult = memoized.apply(void 0, arguments);
    var fresult = fnCall.apply(void 0, memoized.cacheStatistics.lastCallArgs);
    functor.isPure = !memoized.cacheStatistics.memoizationDisabled;

    if (functor.isPure && lastResult) {
      if (lastResult !== fresult) {
        if (lastMemoizedResult === mresult) {
          functor.isPure = shallowTest(lastResult, fresult, onTrigger, message, fnCall, '`s result is not equal at [$KEYS$], while should be equal');
        }
      }
    }

    lastResult = fresult;
    lastMemoizedResult = mresult;
    return mresult;
  }

  return functionDouble(functor, fnCall);
};
export var shouldBePure = function shouldBePure(fnCall, options) {
  return process.env.NODE_ENV === 'production' ? fnCall : shallBePure(fnCall, options);
};